var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.492 1.66406H6.50866C3.47533 1.66406 1.66699 3.4724 1.66699 6.50573V13.4807C1.66699 16.5224 3.47533 18.3307 6.50866 18.3307H13.4837C16.517 18.3307 18.3253 16.5224 18.3253 13.4891V6.50573C18.3337 3.4724 16.5253 1.66406 13.492 1.66406Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M9.99987 8.58958C10.6028 8.58958 11.0915 8.10083 11.0915 7.49792C11.0915 6.89501 10.6028 6.40625 9.99987 6.40625C9.39696 6.40625 8.9082 6.89501 8.9082 7.49792C8.9082 8.10083 9.39696 8.58958 9.99987 8.58958Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M6.92516 11.4062C6.32516 11.4062 5.8335 11.8979 5.8335 12.4979C5.8335 13.0979 6.32516 13.5896 6.92516 13.5896C7.52516 13.5896 8.01683 13.0979 8.01683 12.4979C8.01683 11.8979 7.52516 11.4062 6.92516 11.4062Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.97,
    d: "M13.076 11.4062C12.476 11.4062 11.9844 11.8979 11.9844 12.4979C11.9844 13.0979 12.476 13.5896 13.076 13.5896C13.676 13.5896 14.1677 13.0979 14.1677 12.4979C14.1677 11.8979 13.676 11.4062 13.076 11.4062Z",
    fill: "#333548",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon06);
export default __webpack_public_path__ + "static/media/menu-icon-06.57b9ab30fb34b37fe6130131f7f4d69b.svg";
export { ForwardRef as ReactComponent };